import { Nullable } from "@/general/custom-types/CustomTypes";

export class CustomerAutocompleteModel {
  id: Nullable<number>;
  name: Nullable<string>;

  constructor(id?: number, name?: string) {
    this.id = id;
    this.name = name;
  }
}
